// eslint-disable-next-line jira/filename-case, jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
// eslint-disable-next-line jira/restricted/react-intl
import { IntlProvider as IntlProviderV5 } from 'react-intl';

/**
 * Most of the time, you may not need this component and wrap your component because
 * when rendering your component in a SPA page, your component is already wrapped inside `IntlProvider` in upper level.
 * If you really need to use this component, you mostly need to pass `messages` props to it
 * because other components of `react-intl` needs to look up message in the nearest `IntlProvider` in the component tree.
 * If the nearest `IntlProvider` does not have the right message matching with current locale,
 * it stops to look up messages right away and fall back to use the default message in English.
 */
export const IntlProvider = ({
	children,
	...props
}: ComponentProps<typeof IntlProviderV5>): React.JSX.Element => (
	<IntlProviderV5 {...props} defaultLocale={props.locale}>
		{children}
	</IntlProviderV5>
);
